"use client";
import { useRouter } from "next/navigation";
import { FC, useMemo } from "react";
import { Select } from "../ui";
import { IPravacyPolicySelectTypeProps } from "./privacy-policy-select-type.types";

export const PrivacyPolicySelectType: FC<IPravacyPolicySelectTypeProps> = ({ types, selectedType }) => {
  const options = useMemo(() => types.map(({ slug, name }) => ({ value: slug, label: name })), [types]);
  const defaultType = options.find((el) => el.value === selectedType?.slug);

  const router = useRouter();

  const routeRoot = "/privacy-policy";

  return (
    <div className="flex flex-col md:flex-row  gap-[16px] md:gap-[22px] w-full items-start md:items-center">
      <span className="font-fustat font-[600] tracking-[-4%]  text-[16px uppercase text-nowrap">View policy for:</span>

      <Select
        wrapperClassName="w-full md:w-[320px]"
        label=""
        options={options}
        defaultValue={defaultType ?? options[0]}
        onSelect={(v) => router.push([routeRoot, v!.value].join("/"), { scroll: false })}
      />
    </div>
  );
};
